import type { GameDescriptor } from '@everyturn/engine/runtime';

export const stripTestDescriptor = {
  gameId: 'strip-test',
  displayName: 'Zone Strip Test',
  seats: ['south'],
  minPlayers: 1,
  maxPlayers: 1,
  defaultSeat: 'south',
} as const satisfies GameDescriptor;
